import { Text, VStack } from '@chakra-ui/react';
import { useEffect } from 'react';
import { EmailBlockSection } from '../../../components/EmailBlockSection';
import type { InterviewCommPanelBaseProps } from './types';
import { TemplatedEmail } from '../../../components/TemplatedEmail';

export const SelfScheduleCommunicationPanel = ({
  state,
  dispatch,
  fieldErrors,
  selfScheduleTemplateOptions,
  fromOptions,
  ccBccOptions,
  selfScheduleVariables,
  uploadInlineImage,
}: InterviewCommPanelBaseProps) => {
  const showRequiredVariableHint = Boolean(
    fieldErrors.selfSchedule?.content?.includes(
      '{{interview.self_schedule_link}}'
    )
  );

  useEffect(() => {
    if (!state.selfScheduleEnabled) return;
    console.log(
      '[InterviewActivity][SelfSchedulePanel] error visibility state',
      {
        showRequiredVariableHint,
        selfScheduleErrors: fieldErrors.selfSchedule,
      }
    );
  }, [
    fieldErrors.selfSchedule,
    showRequiredVariableHint,
    state.selfScheduleEnabled,
  ]);

  return (
    <VStack align="stretch" spacing="4" w="100%">
      <EmailBlockSection
        title="Self-schedule slot selection email"
        sectionId="interview-comm-self-schedule"
        description="Candidates get this email to select their interview slot for self-schedule interviews."
        showSwitch
        switchChecked={state.selfScheduleEnabled}
        onSwitchChange={(checked) =>
          dispatch({ type: 'SET_SELF_SCHEDULE_ENABLED', payload: checked })
        }
      >
        {state.selfScheduleEnabled ? (
          <>
            <TemplatedEmail
              className="w-full"
              showFrom
              showTo={false}
              showSubject
              enableCcBcc
              showTemplate
              showEditor
              editorVariant="richEmail"
              variables={selfScheduleVariables}
              attachments={state.selfScheduleAttachments}
              onAttachmentsChange={(items) =>
                dispatch({
                  type: 'SET_SELF_SCHEDULE_ATTACHMENTS',
                  payload: items,
                })
              }
              templateOptions={selfScheduleTemplateOptions}
              fromOptions={fromOptions}
              ccBccOptions={ccBccOptions}
              applyTemplateBodyToEditor
              value={state.selfSchedule}
              onChange={(value) =>
                dispatch({ type: 'SET_SELF_SCHEDULE', payload: value })
              }
              errors={fieldErrors.selfSchedule}
              placeholders={{
                from: 'Select from',
                subject: 'Subject',
                template: 'Select a template',
              }}
              uploadInlineImage={uploadInlineImage}
            />
            {showRequiredVariableHint ? (
              <Text mt="2" fontSize="xs" color="error-200">
                Required variable:{' '}
                <strong>{'{{interview.self_schedule_link}}'}</strong>
              </Text>
            ) : null}
          </>
        ) : null}
      </EmailBlockSection>
    </VStack>
  );
};
